<template>
  <div data-lo="UiRule" class="w-full border-t border-[#d0cbc3]" />
</template>
